import { getElements, ifSelectorExist } from "./utils";

export const eventsFilter = () => {
  const categories = document.querySelectorAll(".category-tab");
  const posts = document.querySelectorAll(".events-post");

  categories.forEach((category) => {
    category.addEventListener("click", function () {
      const selectedCategoryId = this.getAttribute("data-category-id");

      // Highlight the active category
      document.querySelector(".category-tab.active").classList.remove("active");
      this.classList.add("active");

      // Show/hide posts based on the selected category
      posts.forEach((post) => {
        const postCategories = post.getAttribute("data-category-ids").split(",");
        const isPostPlaceholder = post.classList.contains("post-placeholder");

        if (
          selectedCategoryId === "0" && isPostPlaceholder
        ) {
          // Keep post-placeholder hidden when "All categories" is selected
          post.classList.add("hide");
        } else if (
          selectedCategoryId === "0" || postCategories.includes(selectedCategoryId)
        ) {
          post.classList.remove("hide");
        } else {
          post.classList.add("hide");
        }
      });
    });
  });
};